import React, { createContext } from "react"
import Modal from "react-modal"
import { defaultModalStyle } from "../../../../shared/state/sharedTypes"
import ModalContainer from "../../../../shared/components/modals/ModalContainer"
import CaseAssetViewer from "./CaseAssetViewer"

interface Props {
  isOpen: boolean
  closeModal: () => void
  selectedAssetId: string
}
export interface ICaseAssetModalContext {
  closeModal: VoidFunction
}

export const CaseAssetModalContext = createContext<ICaseAssetModalContext>(null)

const ViewAssetModal: React.FC<Props> = (props: Props) => {
  return (
    <Modal isOpen={props.isOpen} onRequestClose={props.closeModal} style={defaultModalStyle}>
      <ModalContainer handleClose={props.closeModal}>
        <CaseAssetModalContext.Provider value={{ closeModal: props.closeModal }}>
          <CaseAssetViewer assetId={props.selectedAssetId} />
        </CaseAssetModalContext.Provider>
      </ModalContainer>
    </Modal >
  )
}

export default ViewAssetModal
